:host {
  .container {
    padding: 20px 40px 40px;
  }

  .inner-container {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .buttons {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
  }

  .hidden {
    display: none;
  }

  .label {
    color: $ui-blue;
    font-weight: $font-weight-bold;
  }

  .sticky {
    position: sticky;
    bottom: 0;
  }
}
